module.exports = __webpack_public_path__ + "img/lens-167-minus-02.52d2eb59.png";